const changeAutomaticEmailsStr = {
  toastr: 'changed data'
};

export default changeAutomaticEmailsStr;
